import { MS_OAUTH_ENDPOINT } from '../variables/GlobalVariables';

export function isHiFiveWorkProject() {
  return MS_OAUTH_ENDPOINT.includes('hifivework');
}

export function isHiFiveWorkDemo() {
  return MS_OAUTH_ENDPOINT.includes('api-pp.hifivework.com');
}
